import { render, staticRenderFns } from "./radioGroup.vue?vue&type=template&id=4392a089&scoped=true"
import script from "./radioGroup.vue?vue&type=script&lang=js"
export * from "./radioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392a089",
  null
  
)

export default component.exports